module.exports = __webpack_public_path__ + "img/googlepay.990fb2be.svg";